module.exports = __webpack_public_path__ + "img/banner.e832f10e.png";